<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Producto"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="mt-2 mb-2">
          <p-fieldset legend="Artículo" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label>Artículo</label>
                <input pInputText formControlName="item" type="text" />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.item.openDialog = true"
                  pTooltip="Seleccionar Artículo"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="mt-3 mb-2">
          <p-fieldset legend="Laboratorio" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label>Descripción</label>
                <input pInputText formControlName="laboratory" type="text" />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.laboratory.openDialog = true"
                  pTooltip="Seleccionar Laboratorio"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="mt-3 mb-2">
          <p-fieldset legend="Unidad de Medida" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label>Descripción</label>
                <input pInputText formControlName="unitMeasure" type="text" />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.unitMeasure.openDialog = true"
                  pTooltip="Seleccionar Unidad de Medida"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="p-fluid p-formgrid grid mt-3 mb-2">
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar Cambios"
              tooltipPosition="top"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="!readyToCreate"
              label="Si"
              tooltipPosition="top"
              pTooltip="Guardar Cambios"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>

<pg-item-select
  *ngIf="select.item.openDialog"
  (selectedRowsEvent)="onSelectedItem($event)"
></pg-item-select>

<pg-laboratory-select
  *ngIf="select.laboratory.openDialog"
  (selectedRowsEvent)="onSelectedLaboratory($event)"
></pg-laboratory-select>

<pg-unit-measure-select
  *ngIf="select.unitMeasure.openDialog"
  (selectedRowsEvent)="onSelectedUnitMeasure($event)"
></pg-unit-measure-select>
